import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { GlobalsService } from '../globals-services/globals.service';

@Component({
  selector: 'app-admin-chem-iq-status',
  templateUrl: './admin-chem-iq-status.component.html',
  styleUrls: ['./admin-chem-iq-status.component.css']
})
export class AdminChemIqStatusComponent implements OnInit {
  chemIqStatusList: any;
  isLoading: boolean = false;

  constructor(
              private http: HttpClient,
              private globalsService: GlobalsService
              ) 
              { }

  ngOnInit(): void {
    this.getChemIqStatusList()
  }
  getChemIqStatusList() {
    this.isLoading = true;
    this.http.get<any>(this.globalsService.baseHref + '/getChemIqStatusList').subscribe(
      (response) => {
        this.chemIqStatusList = response;
        console.info(this.chemIqStatusList)

        setTimeout(
          () => {
            this.isLoading = false
          }, 2000
        );
      },
      (error) => {
        this.isLoading = true
        setTimeout(
          () => {
            this.isLoading = false
          }, 2000
        );
      }
    )
  }
}
